import React, { useState, useContext  } from "react";
import {  Image, Text, View, Pressable } from "react-native";
import { style_templates} from "../config_variables/styles";
import { variables } from "../config_variables/variables";
import { useNavigation } from '@react-navigation/native';
import calculateCompletePctg from "../utils/calculateCompletePctg";
import Icon2 from "react-native-vector-icons/FontAwesome";
import { LinearGradient } from 'expo-linear-gradient';
import convertNumberToCurrency from "../utils/convertNumberToCurrency";
import IsFinalCalledUp from "../utils/IsFinalCalledUp"
import images  from '../utils/images';
import { DataContext } from "../store/data-context";

// export default function Card({filtercategory, cardData, WINDOW_HEIGHT}) {
export default function Card(props) {
  // console.log('inside Card component | props.filtercategory :  ' + props.filtercategory)
    const navigation = useNavigation();
  const dataCtx = useContext(DataContext);

  function cardPressHandler(e) {
    console.log("card pressed | props.filtercategory : " + props.filtercategory);
    console.log('e.target.style.color: ' + e.target.style.color)

    if(props.filtercategory != 'lot') {
    props.showLotsHandler(
      props.cardData.sfid,
      props.cardData.name,
      props.filtercategory
    );
    } else {
      console.log('just before navigating to Lot screen | props.cardData.sfid : ' + props.cardData.sfid + ' | props.cardData.name : ' + props.cardData.name)
      console.log('props.cardData: ' + JSON.stringify(props.cardData))
      dataCtx.setLotrec(props.cardData.lotrecord)
      //   navigation.navigate("Lot" , {
      //     // lotdetails : props.cardData
      //     lotdetails : props.cardData.lotrecord
      //   });
      // props.showLotDetailHandler(props.cardData)
    }

    }
//     if(props.filtercategory == 'lot') {

//   }

  function formatCompletion(x) {
    return x * 100;
  }

  const isTranche = props.filtercategory === "tranche" ? true : false
  const iconSize = variables.isDesktop ? 20 : 30
  const iconSizeLotListCard = 16

    const color_red = {
        backgroundColor: "red"
    };
        const color_blue = {
        backgroundColor: "blue"
    };    const color_orange = {
        backgroundColor: "orange"
    };    const color_green = {
        backgroundColor: "green"
    };


  if (props.filtercategory != "lot" ) {
      
      // if (props.filtercategory == "tranche" || props.filtercategory == "milestone") {
    return (
      <Pressable onPress={cardPressHandler}>

        <View style={[style_templates.card_template, {width: Object.keys(dataCtx.lotrec).length > 0 ? 380 : 480}]}>
    {/* <LinearGradient
        colors={['#c0392b', '#f1c40f', '#8e44ad']}
        start={{x: 0, y: 0.5}}
        end={{x: 1, y: 1}}
        style={style_templates.card_template}
      > */}
         

          {isTranche &&
  <>

      <View style={style_templates.tranche_number_box}>
            <Text style={style_templates.tranche_sub_text}>Tranche</Text>
            {/* <Text style={style_templates.non_tranche_main_text}>
              {props.cardData.name}
            </Text> */}
            <Text style={style_templates.tranche_main_text}>
              {props.cardData.name}
            </Text>
          </View>
          </>
          }


          {!isTranche && 
<View style={style_templates.tranche_number_box}>
            {/* <Text style={style_templates.tranche_sub_text}>Tranche</Text> */}
            {/* <Text style={style_templates.non_tranche_main_text}>
              {props.cardData.name}
            </Text> */}
            <Text style={style_templates.non_tranche_main_text}>
              {props.cardData.name}
            </Text>
          </View>
          }

          <View style={style_templates.generic_box}>
            <Icon2 name="file-text-o" size={iconSize} color="#f08080" />
            <Text style={style_templates.generic_sub_text}>
             {/* Total Lots : {props.cardData.count} */}
              {props.cardData.count}
            </Text>
            <>
            {/* { variables.isDesktop  && */}
            <Text style={style_templates.generic_sub_text_description}>
              Total Lots
            </Text>
            {/* } */}
          </>
          </View>

          <View style={style_templates.generic_box}>
            {/* <Icon name="home-outline" size={iconSize} color="#4F8EF7" /> */}
            <Icon2 name="bank" size={iconSize} color="#808000" />
            <Text style={style_templates.generic_sub_text}>
              {/* Land Settled = {props.cardData.landsettled} */}
              {props.cardData.landsettled}
            </Text>
             <>
              { variables.isDesktop  &&
            <Text style={style_templates.generic_sub_text_description}>
              Land settled
            </Text>
            }
                          { !variables.isDesktop  &&
            <Text style={style_templates.generic_sub_text_description}>
              Settled
            </Text>
            }
          </>            
          </View>

          <View style={style_templates.generic_box}>
            <Icon2 name="pencil" size={iconSize} color="#778899" />
            <Text style={style_templates.generic_sub_text}>
              {/* Settlement Claim : {props.cardData.settlementclaimdone} */}
              {props.cardData.settlementclaimdone}              
            </Text>
             <>
              { variables.isDesktop  &&
            <Text style={style_templates.generic_sub_text_description}>
              Settlement Call
            </Text>            
            }
              { !variables.isDesktop  &&
            <Text style={style_templates.generic_sub_text_description}>
              Settlement Call
            </Text>            
            }
          </>            
          </View>

          <View style={style_templates.generic_box}>
            {/* <Icon name="home-outline" size={iconSize} color="#4F8EF7" /> */}
            <Icon2 name="bank" size={iconSize} color="#808000" />
            <Text style={style_templates.generic_sub_text}>
              {/* Land Settled = {props.cardData.landsettled} */}
              {props.cardData.housesettled}
                  </Text>
                  <>
                  { variables.isDesktop  &&
                  <Text style={style_templates.generic_sub_text_description}>
                  House Settled
                  </Text>
                  }
                              { !variables.isDesktop  &&
                  <Text style={style_templates.generic_sub_text_description}>
                  House Settled
                  </Text>
            }
          </>            
          </View>

          
          <View style={style_templates.generic_box}>
            <Icon2 name="check-square-o" size={iconSize} color="#8fbc8f" />
            <Text style={style_templates.generic_sub_text}>
              {/* Leased ={props.cardData.leased} */}
              {props.cardData.leased}
            </Text>
             <>
              { variables.isDesktop  &&
            <Text style={style_templates.generic_sub_text_description}>
              Leased
            </Text>                        
            }
              { !variables.isDesktop  &&
            <Text style={style_templates.generic_sub_text_description}>
              LEAP
            </Text>                        
            }            
          </>            
          </View>

          <View style={style_templates.progress_box}>
            <Icon2 name="signal" size={iconSize} color="#8fbc8f" />
            <Text style={style_templates.progress_main_text}>
              { (props.cardData.completepctg / props.cardData.count * 100).toFixed(0) }
              {/* { (props.cardData.completepctg).toFixed(0) } */}
              %
            </Text>
            {/* <Text style={style_templates.progress_sub_text}>complete</Text> */}
                        <Text style={style_templates.generic_sub_text_description}>
              Complete
            </Text>     
          </View>


{/* { variables.isDesktop  &&
<>
          <View style={style_templates.generic_box}>
            <Icon2 name="cube" size={iconSize} color="#778899" />
            <Text style={style_templates.generic_sub_text}>
              {(props.cardData.totalsize / props.cardData.count).toFixed(0)} sq m
            </Text>
              { variables.isDesktop  &&
            <Text style={style_templates.generic_sub_text_description}>
              Avg. Land Size
            </Text>                        
            }
          </View>

          <View style={style_templates.generic_box}>
            <Icon2 name="home" size={iconSize} color="#8fbc8f" />
            <Text style={style_templates.generic_sub_text}>
              {(props.cardData.totalhousesize / props.cardData.count).toFixed(0)} sq m
            </Text>
            <Text style={style_templates.generic_sub_text_description}>
              Avg. House Size
            </Text>                        
          </View>

          <View style={style_templates.generic_box}>
            <Icon2 name="usd" size={iconSize} color="#8fbc8f" />
            <Text style={style_templates.generic_sub_text}>
              $ {(props.cardData.landprice / props.cardData.count / 1000).toFixed(0)} K
            </Text>
             <>
              { variables.isDesktop  &&
            <Text style={style_templates.generic_sub_text_description}>
              Avg. Land Price
            </Text>                        
            }
          </>            
          </View>

          <View style={style_templates.generic_box}>
            <Icon2 name="usd" size={iconSize} color="#8fbc8f" />
            <Text style={style_templates.generic_sub_text}>
              {(props.cardData.totalbuildprice  / props.cardData.count / 1000).toFixed(0)} K
            </Text>
             <>
              { variables.isDesktop  &&
            <Text style={style_templates.generic_sub_text_description}>
              Avg. Build Price
            </Text>                        
            }
          </>            
          </View>

          <View style={style_templates.generic_box}>
            <Icon2 name="usd" size={iconSize} color="#8fbc8f" />
            <Text style={style_templates.generic_sub_text}>
              $ {(props.cardData.landprice /  1000000).toFixed(2)} M
            </Text>
             <>
              { variables.isDesktop  &&
            <Text style={style_templates.generic_sub_text_description}>
              Total Land Price
            </Text>                        
            }
          </>            
          </View>

          <View style={style_templates.generic_box}>
            <Icon2 name="usd" size={iconSize} color="#8fbc8f" />
            <Text style={style_templates.generic_sub_text}>
              {(props.cardData.totalbuildprice  / 1000000).toFixed(2)} M
            </Text>
             <>
              { variables.isDesktop  &&
            <Text style={style_templates.generic_sub_text_description}>
              Total Build Price
            </Text>                        
            }
          </>            
          </View>



          </>
  } */}
      {/* </LinearGradient>     */}
        </View>
      </Pressable>
    );
  } else if (props.filtercategory == "lot") {

      let stage_name= props.cardData.lotrecord ? props.cardData.lotrecord.Stage__r != null ? props.cardData.lotrecord.Stage__r.Name : "" : ""
      let tranche = props.cardData.lotrecord ? props.cardData.lotrecord.Trancher__c != null ? props.cardData.lotrecord.Trancher__c : "" : ""
      // let specs = props.cardData.lotrecord ? ' ,Frontage: ' + props.cardData.lotrecord.LandFrontage__c + ' m' + ' , Depth: ' + props.cardData.lotrecord.LandDepth__c + ' m' +  ' , Size: ' + props.cardData.lotrecord.LandSize_r__c + ' sqm' : ""
      let specs = props.cardData.lotrecord ? 'F: ' + props.cardData.lotrecord.LandFrontage__c + ' m' + ' | D: ' + props.cardData.lotrecord.LandDepth__c + ' m' +  ' | S: ' + props.cardData.lotrecord.LandSize_r__c + ' sqm' : ""
      let project_name_for_logo = props.cardData.lotrecord ? props.cardData.lotrecord.Project__r != null ? props.cardData.lotrecord.Project__r.Name : 'Eynesbury PROJECT' : 'Eynesbury PROJECT'
      let logo_uri = images[project_name_for_logo] ? images[project_name_for_logo] : ""
      let lot_name =  props.cardData.lotrecord ? props.cardData.lotrecord.Name : "" 
      let land_price =  props.cardData.lotrecord ? props.cardData.lotrecord.Price__c : ""
      let allocation_group = props.cardData.lotrecord ? props.cardData.lotrecord.AllocationGroup__c : ""
      let product_allocated_to = props.cardData.lotrecord ? props.cardData.lotrecord.ProductAllocatedTo__c : ""
      let allocation_row = "Group : " + allocation_group + ' | Allocation: ' + product_allocated_to
      // let land_price =  props.cardData.lotrecord ? props.cardData.lotrecord.LatestMasterContract__r != null ? props.cardData.lotrecord.LatestMasterContract__r.LandContractPrice__c : props.cardData.lotrecord.Price__c : ""
      // let build_price =  props.cardData.lotrecord ? props.cardData.lotrecord.LatestMasterContract__r != null ? props.cardData.lotrecord.LatestMasterContract__r.BuildContractPrice__c + props.cardData.lotrecord.LatestMasterContract__r.PropertyContractPrice__c : "" : ""
      let isLandSettled = props.cardData.lotrecord ? props.cardData.lotrecord.StatusDevr__c == 'Settled' ? true : false : false
      // let isHosueSettled = props.cardData.lotrecord ? props.cardData.lotrecord.StatusDevr__c == 'Settled' ? true : false : false
      // let isFinalClaim = props.cardData.lotrecord ? IsFinalCalledUp(props.cardData.lotrecord.Milestone__c) ? true : false : false
      // let full_address = props.cardData.lotrecord ? props.cardData.lotrecord.StreetNumber__c + ' , ' + props.cardData.lotrecord.StreetName__c + ' , ' + props.cardData.lotrecord.Suburb__c + ' , ' + props.cardData.lotrecord.State__c + ' , ' +  props.cardData.lotrecord.Postcode__c : ""
      // let address_line1 = props.cardData.lotrecord ? props.cardData.lotrecord.StreetNumber__c + ' , ' + props.cardData.lotrecord.StreetName__c : ""
      // let address_line2 = props.cardData.lotrecord ? props.cardData.lotrecord.Suburb__c + ' , ' + props.cardData.lotrecord.State__c + ' , ' +  props.cardData.lotrecord.Postcode__c : ""
      // let isLeased =props.cardData.lotrecord ? 
      //         props.cardData.lotrecord.LatestMasterContract__r !== null
      //           ? props.cardData.lotrecord.LatestMasterContract__r.ContractLifecycle__r !== null
      //             ? props.cardData.lotrecord.LatestMasterContract__r.ContractLifecycle__r.LEAPLeaseStatus__c == "Leased"
      //               ? true
      //               : false
      //             : false
      //           : false : false
      // let completion_pctg = props.cardData.lotrecord ? (calculateCompletePctg(props.cardData.lotrecord.StatusDevr__c, props.cardData.lotrecord.Milestone__c) * 100).toFixed(0)  : ""
      // console.log('project_name_for_logo: ' + project_name_for_logo)
      // console.log('logo_uri: ' + logo_uri)
      return (
      <Pressable onPress={cardPressHandler}>
            <View style={style_templates.lot_card_template}>
                  <View style={style_templates.lot_card_template_text_container}>
                        <View style={style_templates.screen3_row_container}>
                              {tranche == "" && (
                                <Text style={style_templates.lot_name}>
                                  {lot_name}
                                </Text>
                              )}
                              {tranche != "" && (
                                <Text style={style_templates.lot_name}>
                                  {lot_name}  | BTR { tranche}
                                </Text>
                              )}
                                    {isLandSettled ? <View style = {[style_templates.circle_ind_lots_screen, {backgroundColor: "rgb(107, 107, 182)"}]}></View> : ""}
                                    {/* {isFinalClaim ?  <View style = {[style_templates.circle_ind_lots_screen, {backgroundColor: "rgb(241, 118, 143)"}]}></View>  : ""} */}
                                    {/* {isLeased ?  <View style = {[style_templates.circle_ind_lots_screen, {backgroundColor: "#9acd32"}]}></View>  : ""} */}
                              {/* <Text style={style_templates.lot_card_template_text_labels}>
                                    <Icon2 name="hourglass-2" size={iconSizeLotListCard} color="#8fbc8f" /> 
                              </Text>
                              <Text style={style_templates.lot_card_template_text_values}> {completion_pctg} % complete</Text>                               */}
                        </View>
                              {/* <Text style={style_templates.lot_card_template_text_labels}><Icon2 name="street-view" size={iconSizeLotListCard} color="#8fbc8f" /> </Text> */}
                        {/* <View style={style_templates.screen3_row_container}>
                              <Text style={style_templates.lot_card_template_text_values}>{address_line1} </Text>
                        </View>
                        <View style={style_templates.screen3_row_container}>
                              <Text style={style_templates.lot_card_template_text_values}>{address_line2} </Text>
                        </View> */}
                        <View style={style_templates.screen3_row_container}>
                              <>
                              <Text style={style_templates.lot_card_template_text_values}>{stage_name}</Text>
                              </>
                        </View>
                        <View style={style_templates.screen3_row_container}>
                              <Text style={style_templates.lot_card_template_text_values}>{allocation_row}</Text>
                        </View>
                        <View style={style_templates.screen3_row_container}>
                              <Text style={style_templates.lot_card_template_text_values}>{specs}</Text>
                        </View>
                        {/* <View style={style_templates.screen3_row_container}>
                               {isLandSettled ? <View style = {[style_templates.circle_ind_lots_screen, {backgroundColor: "blue"}]}></View> : ""}
                               {isFinalClaim ?  <View style = {[style_templates.circle_ind_lots_screen, {backgroundColor: "crimson"}]}></View>  : ""}
                               {isLeased ?  <View style = {[style_templates.circle_ind_lots_screen, {backgroundColor: "#9acd32"}]}></View>  : ""}
                        </View> */}

                              {/* <Text style={style_templates.lot_card_template_text_values}> {completion_pctg} % complete</Text>                               */} 
                        
                        <View style={style_templates.screen3_row_container}>
                                    {/* <Text style={style_templates.lot_card_template_text_labels}>L: </Text> */}
                                    <Text style={style_templates.lot_card_template_text_labels}><Icon2 name="street-view" size={iconSizeLotListCard} color="#8fbc8f" /> </Text>
                                    <Text style={style_templates.lot_card_template_text_values}>{convertNumberToCurrency(land_price) }</Text>
                                    {/* <Text style={style_templates.lot_card_template_text_labels}> | B: </Text> */}
                                    {/* <Text style={style_templates.lot_card_template_text_labels}> | <Icon2 name="home" size={iconSizeLotListCard} color="#8fbc8f" />  </Text> */}
                                    {/* <Text style={style_templates.lot_card_template_text_values}>{convertNumberToCurrency(build_price) }</Text> */}
                                    {/* <Text style={style_templates.lot_card_template_text_labels}> | Pkg: </Text> */}
                                    {/* <Text style={style_templates.lot_card_template_text_labels}> | <Icon2 name="gavel" size={iconSizeLotListCard} color="#8fbc8f" /></Text> */}
                                    {/* <Text style={style_templates.lot_card_template_text_values}>{convertNumberToCurrency(land_price+build_price) }</Text> */}
                        </View>
                  </View>
                  <View style={style_templates.tranche_number_box_lot}>
                        <Image
                              // source={require('../assets/logos/'+project_name_for_logo+'.png')}
                              source={logo_uri}
                              // source={'https://resimaxgroup--c.documentforce.com/sfc/dist/version/download/?oid=00D7F000006kPQU&ids=0687F00000ykHiB&d=%2Fa%2F7F000000UbwB%2FtZrJziqm5rY20Bq3POQF42hUoGuaRs4qWpze3eD_U2Q&asPdf=false'}
                              style={style_templates.ImageIconStyle}
                        />
                  </View>
            </View>
      </Pressable>
    );
  } else {
    return (
      <Pressable onPress={cardPressHandler}>
        <View style={style_templates.summary_card_template}>
          <Text style={style_templates.summary_card_title}>
            {props.cardData.name}
          </Text>
          <Text style={style_templates.summary_card_sub_title}>
            {props.cardData.count}
          </Text>
        </View>
      </Pressable>
    );
  }
}






      //     <View style={style_templates.lot_number_box}>
      //         <Text style={style_templates.lot_number_main_text}>
      //           {props.cardData.name}
      //         </Text>
      //        <>
      //         { variables.isDesktop  &&
      //       <Text style={style_templates.generic_sub_text_description}>
      //         Lot Number
      //       </Text>
      //       }
      //     </>            
      //     </View>

      //     <View style={style_templates.generic_box}>
      //     {/* <View style={style_templates.generic_box_lot}> */}
      //     <Text>{props.cardData.status}</Text>
      //        <>
      //         { variables.isDesktop  &&
      //       <Text style={style_templates.generic_sub_text_description}>
      //         Land Contract Status
      //       </Text>
      //       }
      //     </>            
      //       </View>

      //     {/* <Text>{props.cardData.projname}</Text>
      //     <Text>{props.cardData.stage}</Text> */}
      //     <View style={style_templates.generic_box}>
      //     {/* <View style={style_templates.generic_box_lot}> */}
      //       {/* <Icon2 name="tachometer" size={iconSize} color="#8fbc8f" /> */}
      //       {/* <Text style={style_templates.generic_sub_text}></Text> */}
      //       <Text>{props.cardData.lateststage} Stage</Text>
      //        <>
      //         { variables.isDesktop  &&
      //       <Text style={style_templates.generic_sub_text_description}>
      //         Last Milestone
      //       </Text>
      //       }
      //     </>            
      //     </View>

      //     <View style={style_templates.generic_box}>
      //     {/* <View style={style_templates.generic_box_lot}> */}
      //       <Icon2 name="usd" size={iconSize} color="#8fbc8f" />
      //       {/* <Text style={style_templates.generic_sub_text}></Text> */}
      //       <Text>{(props.cardData.price / 1000).toFixed(0)}K</Text>            
      //        <>
      //         { variables.isDesktop  &&
      //       <Text style={style_templates.generic_sub_text_description}>
      //         Land Price 
      //       </Text>
      //       }            
      //       </>
      //     </View>
      //     {/* <View style={style_templates.generic_box}>
      //       <Icon2 name="usd" size={iconSize} color="#8fbc8f" />
      //       <Text>{(props.cardData.buildprice / 1000).toFixed(0)}K</Text>
      //       <Text style={style_templates.generic_sub_text_description}>
      //         Build Price 
      //       </Text>
      //     </View> */}